import { Component, Input } from '@angular/core';

type IconSize = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14;

@Component({
  selector: 'account-portal-permissions-denied',
  templateUrl: 'permissionsdenied.component.html',
  standalone: false,
})
export class PermissionsDeniedComponent {
  @Input() icon = 'heroicons_solid:lock-closed';

  @Input() iconSize: IconSize = 6;

  @Input() message = 'You do not have permission to access this!';
  @Input() title? = null;
}
